export default __webpack_public_path__ + "static/media/TCEQ-Logo.d21eb3a0.png";